<div class="content__inner">
    <header class="content__title">
        <h1>{{ "orderitems.list.title" | translate }}</h1>
        <small>{{ "orderitems.list.subtitle" | translate }}</small>
    </header>

    <div class="card" *appHasPermission="'ORDERITEMS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "orderitems.list.card.title" | translate }}</h4>
            <div class="actions">
                <button class="float-right btn btn-outline-secondary btn--icon-text" *appHasPermission="'ORDERITEMS.EXPORT'" (click)="downloadOrderItemsCSV()">
                    <i class="zmdi zmdi-download"></i> {{ "orderitems.list.card.export" | translate }}
                </button>
            </div>

            <div class="row datatable-filters">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ "orderitems.filter.startdate.title" | translate }}</label>
                        <div class="row">
                            <div class="col-auto">
                                <input
                                    class="form-control"
                                    type="text"
                                    placeholder="{{ 'orderitems.filter.startdate.placeholder' | translate }}"
                                    bsDatepicker
                                    (bsValueChange)="startFilterChanged($event)"
                                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showMeridian: false, containerClass: 'theme-blue' }"
                                    [(ngModel)]="startDate"
                                />
                            </div>
                            <div class="col-auto time-picker-container right-of-datepicker">
                                <timepicker class="time-picker" [showMeridian]="false" [(ngModel)]="startDate"></timepicker>
                            </div>
                            <div *ngIf="startDate" (click)="resetStartDate()" class="ng-clear-wrapper" title="Clear all"><span aria-hidden="true" class="ng-clear">×</span></div>
                        </div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ "orderitems.filter.enddate.title" | translate }}</label>
                        <div class="row">
                            <div class="col-auto">
                                <input
                                    class="form-control"
                                    type="text"
                                    placeholder="{{ 'orderitems.filter.enddate.placeholder' | translate }}"
                                    bsDatepicker
                                    (bsValueChange)="endFilterChanged($event)"
                                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showMeridian: false, containerClass: 'theme-blue' }"
                                    [(ngModel)]="endDate"
                                />
                            </div>
                            <div class="col-auto time-picker-container right-of-datepicker">
                                <timepicker class="time-picker" [showMeridian]="false" [(ngModel)]="endDate"></timepicker>
                            </div>
                            <div *ngIf="endDate" (click)="resetEndDate()" class="ng-clear-wrapper" title="Clear all"><span aria-hidden="true" class="ng-clear">×</span></div>
                        </div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "orderitems.props.user" | translate }}</th>
                        <td mat-cell *matCellDef="let row" [innerHtml]="row.user?.htmlFormatUser()"></td>
                    </ng-container>

                    <ng-container matColumnDef="itemCount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "orderitems.props.itemcount" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.itemCount }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "orderitems.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date: UTCDATEFORMAT }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <i (click)="viewOrder(row._id)" class="zmdi zmdi-eye zmdi-hc-fw tableIcon" *appHasPermission="'ORDERITEMS.LIST'"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
